import dot from 'dot-object';

export const dotMerge = (data, target) => {
  let changed = false;

  Object.entries(data).forEach(([key, value]) => {
    const oldValue = dot.pick(key, target);

    if (oldValue !== value) {
      changed = true;
      dot.set(key, value, target, false);
    };
  });
  
  return changed;
};